/*
 * header-fixer-custom.js
 * -----------------------------------------------------------------------------
 * Bridges the custom force-fixed header (header-fixer.js) to the theme's sticky
 * system. header-fixer.js sets the header to position:fixed on scroll but does
 * NOT update --theme-sticky-header-height, so theme sticky elements (collection
 * filters, product sticky columns) anchor too high and slide under the header.
 *
 * This script publishes --theme-sticky-header-height = header height while the
 * header is fixed, and resets it to 0 otherwise. Kept separate so the original
 * (non-custom) header-fixer.js stays untouched.
 * -----------------------------------------------------------------------------
 */
(() => {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(() => {
    const header = document.querySelector('.section-header');
    if (!header) return;

    const root = document.documentElement;
    let scheduled = false;

    const apply = () => {
      scheduled = false;
      const isFixed = getComputedStyle(header).position === 'fixed';
      const value = isFixed ? `${Math.ceil(header.getBoundingClientRect().height)}px` : '0px';
      root.style.setProperty('--theme-sticky-header-height', value);
    };

    const sync = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(apply);
    };

    // header-fixer.js toggles the header's position/class as you scroll.
    new MutationObserver(sync).observe(header, { attributes: true, attributeFilter: ['style', 'class'] });
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });

    sync();
  });
})();
